module.exports = `
  type WatermarkPosition {
    watermark_position_id: Int
    name: String 
    active: Boolean
  }
`;
